import { useEffect, useState } from "react";
import { useTranslations } from "@/lib/useTranslations";

import { Button } from "@/components/ui/Button";

interface ShareLinkButtonProps {
  shareUrl: string;
}

export function ShareLinkButton({ shareUrl }: ShareLinkButtonProps) {
  const t = useTranslations("common");
  const [feedback, setFeedback] = useState<string | null>(null);

  useEffect(() => {
    if (!feedback) return;
    const timer = window.setTimeout(() => setFeedback(null), 2000);
    return () => window.clearTimeout(timer);
  }, [feedback]);

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setFeedback(t("linkCopied"));
    } catch {
      setFeedback(t("linkCopyFailed"));
    }
  }

  return (
    <div className="space-y-1.5">
      <Button
        type="button"
        variant="secondary"
        className="w-full"
        onClick={handleCopy}
      >
        {t("copyShareLink")}
      </Button>
      {feedback ? (
        <p className="text-xs text-neutral-500">{feedback}</p>
      ) : null}
    </div>
  );
}
